
import { defineComponent, PropType } from 'vue'
import { ElMenuItem, ElSubMenu } from 'element-plus'
import MenuModel from '@/models/Menu.model'
import 'element-plus/es/components/menu-item/style/css'
import 'element-plus/es/components/sub-menu/style/css'

export default defineComponent({
  name: 'SubmenuListPc',
  components: {
    'el-menu-item': ElMenuItem,
    'el-sub-menu': ElSubMenu
  },
  props: {
    data: { type: Object as PropType<MenuModel>, default: () => {} },
    index: { type: String, default: null }
  },
  setup() {
    const jumpMenu = (link) => link && window.history.pushState({}, '', link)

    return { jumpMenu }
  }
})
